import { AuthenticationService } from '../services/authenticationService';
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';

@Injectable()
export default class AuthenticationGuard implements CanActivate {

  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  canActivate() {
    const isLoggedIn = this.isLoggedIn();

    if (!isLoggedIn) {
      this.router.navigate(['login']);
    }
    return isLoggedIn;
  }

  isLoggedIn(): boolean {
    let isLoggedIn = this.authenticationService && this.authenticationService.isLoggedIn;
    if (!isLoggedIn) {
      isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
    }

    return isLoggedIn;
  }
}



// WEBPACK FOOTER //
// ./src/guards/authenticationGuard.ts